(function(){
  if (window.SharedVideoPlayer && typeof window.SharedVideoPlayer.bind === 'function') return;

  function fmtTime(sec) {
    var s = Math.max(0, Math.floor(Number(sec) || 0));
    var h = Math.floor(s / 3600);
    var m = Math.floor((s % 3600) / 60);
    var ss = s % 60;
    if (h > 0) return h + ':' + String(m).padStart(2, '0') + ':' + String(ss).padStart(2, '0');
    return m + ':' + String(ss).padStart(2, '0');
  }

  function bind(opts) {
    if (!opts) return null;
    var state = {
      video: opts.video || null,
      root: opts.root || null,
      controls: opts.controls || null,
      overlayPlay: opts.overlayPlay || null,
      playBtn: opts.playBtn || null,
      progress: opts.progress || null,
      timeCurrent: opts.timeCurrent || null,
      timeDuration: opts.timeDuration || null,
      muteBtn: opts.muteBtn || null,
      expandBtn: opts.expandBtn || null,
      volumeWrap: opts.volumeWrap || null,
      volumePop: opts.volumePop || null,
      volumeSlider: opts.volumeSlider || null,
      useOverlay: opts.useOverlay !== false,
      hideDelayDesktop: typeof opts.hideDelayDesktop === 'number' ? opts.hideDelayDesktop : 1200,
      hideDelayMobile: typeof opts.hideDelayMobile === 'number' ? opts.hideDelayMobile : 1200,
      hideDelayPausedDesktop: typeof opts.hideDelayPausedDesktop === 'number' ? opts.hideDelayPausedDesktop : 500,
      isDesktop: typeof opts.isDesktop === 'function' ? opts.isDesktop : function() { return window.innerWidth > 749; },
      isFullscreen: typeof opts.isFullscreen === 'function' ? opts.isFullscreen : function() { return false; },
      onSyncInsets: typeof opts.onSyncInsets === 'function' ? opts.onSyncInsets : function(){},
      onExpand: typeof opts.onExpand === 'function' ? opts.onExpand : null,
      onVisibleChange: typeof opts.onVisibleChange === 'function' ? opts.onVisibleChange : null,
      onPoke: typeof opts.onPoke === 'function' ? opts.onPoke : null,
      shouldKeepVisible: typeof opts.shouldKeepVisible === 'function' ? opts.shouldKeepVisible : null,
      isActive: typeof opts.isActive === 'function' ? opts.isActive : null,
      hookSync: typeof opts.syncFn === 'function' ? opts.syncFn : null,
      hookSetVisible: typeof opts.setVisibleFn === 'function' ? opts.setVisibleFn : null,
      hookScheduleHide: typeof opts.scheduleHideFn === 'function' ? opts.scheduleHideFn : null,
      hookPoke: typeof opts.pokeFn === 'function' ? opts.pokeFn : null,
      hookTogglePlay: typeof opts.togglePlayFn === 'function' ? opts.togglePlayFn : null,
      hookOpenVolume: typeof opts.openVolumeFn === 'function' ? opts.openVolumeFn : null,
      hookCloseVolume: typeof opts.closeVolumeFn === 'function' ? opts.closeVolumeFn : null,
      hideTimer: null,
      hideHoldUntil: 0,
      scrubbing: false,
      unsubs: []
    };
 
    function on(el, evt, fn, options) {
      if (!el || !fn) return;
      el.addEventListener(evt, fn, options);
      state.unsubs.push(function() {
        try { el.removeEventListener(evt, fn, options); } catch (_) {}
      });
    }

    function closeVolume() {
      if (state.hookCloseVolume) {
        state.hookCloseVolume();
        return;
      }
      if (!state.volumePop) return;
      state.volumePop.classList.remove('is-open');
      window.setTimeout(function() {
        if (state.volumePop && !state.volumePop.classList.contains('is-open')) state.volumePop.hidden = true;
      }, 720);
    }

    function openVolume() {
      if (state.hookOpenVolume) {
        state.hookOpenVolume();
        return;
      }
      if (!state.volumePop) return;
      state.volumePop.hidden = false;
      requestAnimationFrame(function() {
        requestAnimationFrame(function() {
          if (state.volumePop) state.volumePop.classList.add('is-open');
        });
      });
    }

    function setControlsVisible(visible) {
      if (state.hookSetVisible) {
        state.hookSetVisible(visible);
        return;
      }
      if (!state.controls) return;
      state.controls.hidden = false;
      state.controls.classList.toggle('is-visible', !!visible);
      if (state.onVisibleChange) state.onVisibleChange(!!visible, state);
    }

    function shouldKeepVisible() {
      if (state.isActive && !state.isActive(state)) return false;
      if (state.shouldKeepVisible) return !!state.shouldKeepVisible(state);
      var v = state.video;
      if (!v) return false;
      if (state.volumePop && !state.volumePop.hidden) return true;
      if (!state.isDesktop()) return v.paused || v.ended;
      return false;
    }

    function scheduleHide() {
      if (state.hookScheduleHide) {
        state.hookScheduleHide();
        return;
      }
      if (state.hideTimer) clearTimeout(state.hideTimer);
      var v = state.video;
      if (!v) return;
      if (state.isActive && !state.isActive(state)) {
        setControlsVisible(false);
        return;
      }
      if (v.paused || v.ended) {
        if (!shouldKeepVisible()) {
          if (state.isDesktop() && !state.isFullscreen()) {
            state.hideTimer = setTimeout(function() {
              if (!shouldKeepVisible()) setControlsVisible(false);
            }, state.hideDelayPausedDesktop);
          } else {
            setControlsVisible(false);
          }
        }
        return;
      }
      var delay = state.isFullscreen() ? state.hideDelayDesktop : (state.isDesktop() ? state.hideDelayDesktop : state.hideDelayMobile);
      var now = Date.now();
      if (state.hideHoldUntil && state.hideHoldUntil > now) {
        delay = Math.max(delay, state.hideHoldUntil - now);
      }
      state.hideTimer = setTimeout(function() {
        if (!shouldKeepVisible()) setControlsVisible(false);
      }, delay);
    }

    function poke() {
      if (state.hookPoke) {
        state.hookPoke();
        return;
      }
      if (state.isActive && !state.isActive(state)) return;
      if (state.hideTimer) {
        clearTimeout(state.hideTimer);
        state.hideTimer = null;
      }
      setControlsVisible(true);
      if (state.onPoke) state.onPoke(state);
      scheduleHide();
    }

    function sync() {
      if (state.isActive && !state.isActive(state)) {
        state.reset();
        return;
      }
      if (state.hookSync) {
        state.hookSync();
        return;
      }
      var video = state.video;
      if (!video) return;
      var duration = Number.isFinite(video.duration) ? video.duration : 0;
      var current = Number.isFinite(video.currentTime) ? video.currentTime : 0;
      var playing = !video.paused && !video.ended;
      var pct = duration > 0 ? (current / duration) * 100 : 0;
      if (state.controls) {
        state.controls.classList.toggle('is-overlay-primary', state.useOverlay && !playing);
        state.controls.classList.toggle('is-playing', playing);
        state.controls.style.setProperty('--gm-vp-progress', String(Math.max(0, Math.min(100, pct))));
        state.controls.style.setProperty('--gm-vp-volume', String(Math.round((video.muted ? 0 : video.volume) * 100)));
        state.controls.hidden = false;
      }
      if (state.progress && !state.scrubbing) state.progress.value = String(pct);
      if (state.timeCurrent) state.timeCurrent.textContent = fmtTime(current);
      if (state.timeDuration) state.timeDuration.textContent = fmtTime(duration);
      if (state.volumeSlider && !state.scrubbing) state.volumeSlider.value = String(Math.round((video.muted ? 0 : video.volume) * 100));
      if (state.playBtn) state.playBtn.classList.toggle('is-playing', playing);
      if (state.overlayPlay) {
        state.overlayPlay.classList.toggle('is-playing', playing);
        if (state.useOverlay) {
          var show = !playing;
          state.overlayPlay.hidden = false;
          state.overlayPlay.classList.toggle('is-visible', show);
          state.overlayPlay.classList.toggle('is-hidden', !show);
        } else {
          state.overlayPlay.hidden = true;
          state.overlayPlay.classList.remove('is-visible');
          state.overlayPlay.classList.add('is-hidden');
        }
      }
      if (state.muteBtn) {
        state.muteBtn.classList.toggle('is-muted', video.muted || video.volume === 0);
        state.muteBtn.setAttribute('aria-label', (video.muted || video.volume === 0) ? 'Unmute video' : 'Mute video');
      }
      if (!playing && shouldKeepVisible()) {
        setControlsVisible(true);
      }
      state.onSyncInsets(state);
    }

    function togglePlay() {
      if (state.hookTogglePlay) {
        state.hookTogglePlay();
        return;
      }
      var video = state.video;
      if (!video) return;
      if (video.paused) video.play().catch(function(){});
      else video.pause();
    }

    if (state.root) {
      on(state.root, 'click', function(event) {
        if (event.target.closest('[data-gm-vp-controls], [data-gm-vp-overlay-play], [data-ehmr-modal-video-controls], [data-ehmr-modal-video-overlay-play]')) return;
        togglePlay();
      });
    }
    on(state.overlayPlay, 'click', function(e){
      e.preventDefault();
      e.stopPropagation();
      if (state.isDesktop()) state.hideHoldUntil = Date.now() + 500;
      togglePlay();
      poke();
    });
    on(state.playBtn, 'click', function(e){
      e.preventDefault();
      e.stopPropagation();
      if (state.isDesktop()) state.hideHoldUntil = Date.now() + 500;
      togglePlay();
      poke();
    });
    on(state.expandBtn, 'click', function(e){ e.preventDefault(); e.stopPropagation(); if (state.onExpand) state.onExpand(state); });
    on(state.muteBtn, 'click', function(e){
      e.preventDefault();
      e.stopPropagation();
      poke();
      if (state.volumePop) {
        if (state.volumePop.hidden || !state.volumePop.classList.contains('is-open')) openVolume();
        else closeVolume();
      } else if (state.video) {
        state.video.muted = !state.video.muted;
      }
      sync();
    });
    on(state.volumePop, 'click', function(e){ e.stopPropagation(); });

    if (state.progress) {
      on(state.progress, 'pointerdown', function(){ state.scrubbing = true; });
      on(state.progress, 'pointerup', function(){ state.scrubbing = false; });
      on(state.progress, 'change', function(){ state.scrubbing = false; });
      on(state.progress, 'input', function(e){
        e.stopPropagation();
        var video = state.video;
        if (!video) return;
        var duration = Number.isFinite(video.duration) ? video.duration : 0;
        var pct = Math.max(0, Math.min(100, parseFloat(state.progress.value || '0')));
        if (duration > 0) video.currentTime = (pct / 100) * duration;
        sync();
      });
    }

    if (state.volumeSlider) {
      on(state.volumeSlider, 'input', function(e){
        e.stopPropagation();
        var video = state.video;
        if (!video) return;
        var pct = Math.max(0, Math.min(100, parseFloat(state.volumeSlider.value || '100')));
        video.volume = pct / 100;
        video.muted = pct === 0;
        sync();
      });
    }

    if (state.video) {
      ['play','pause','timeupdate','loadedmetadata','durationchange','volumechange','ended','seeking','seeked'].forEach(function(evt) {
        on(state.video, evt, function() {
          sync();
          if (evt === 'play') scheduleHide();
        });
      });
    }

    state.sync = sync;
    state.poke = poke;
    state.setVisible = setControlsVisible;
    state.scheduleHide = scheduleHide;
    state.reset = function() {
      if (state.hideTimer) {
        clearTimeout(state.hideTimer);
        state.hideTimer = null;
      }
      if (state.controls) {
        state.controls.hidden = true;
        state.controls.classList.remove('is-visible', 'is-playing', 'is-overlay-primary');
        state.controls.style.removeProperty('--gm-vp-progress');
        state.controls.style.removeProperty('--gm-vp-volume');
      }
      if (state.overlayPlay) {
        state.overlayPlay.hidden = true;
        state.overlayPlay.classList.remove('is-visible', 'is-hidden', 'is-playing');
      }
      if (state.volumePop) {
        state.volumePop.classList.remove('is-open');
        state.volumePop.hidden = true;
      }
    };
    state.destroy = function() {
      state.reset();
      state.unsubs.forEach(function(fn){ try { fn(); } catch (_) {} });
      state.unsubs = [];
    };
    state.state = state;
    return state;
  }

  window.SharedVideoPlayer = { bind: bind };
  window.GMSharedVideoPlayer = window.GMSharedVideoPlayer || window.SharedVideoPlayer;
})();
